export const environment = {
    shopId: 'ChIJFUYyOIDMl0cRHWato2iVVZE',
    useEmulators: false,
    isAdminPage: false,
    firebaseConfig: {
        apiKey: "AIzaSyB4zNi3CZ0SlZAz3s3ujs2a84naoQ_aJF8",
        authDomain: "flora1-crm.firebaseapp.com",
        projectId: "flora1-crm",
        storageBucket: "flora1-crm.appspot.com",
        locationId: "europe-west",
        messagingSenderId: "606676380717",
        appId: "1:606676380717:web:f38168c0011fa223179ca4",
        measurementId: "G-Q7LN66SEVH"
    }
};